import React, { useState } from "react";

const NEON_CYAN = "#00f2ff";

function AdminPacksWebPage() {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedPack, setSelectedPack] = useState(null);

  const [packs, setPacks] = useState([
    { id: "1", name: "Pack Débutant", coins: "100", price: "1.00" },
    { id: "2", name: "Pack Bronze", coins: "200", price: "2.00" },
    { id: "3", name: "Pack Argent", coins: "300", price: "3.00" },
    { id: "4", name: "Pack Or", coins: "500", price: "5.00" },
    { id: "5", name: "Pack Or +", coins: "1000", price: "10.00" },
    { id: "6", name: "Pack Diamant", coins: "1500", price: "15.00" },
    { id: "7", name: "Pack Diamant +", coins: "1700", price: "17.00" },
    { id: "8", name: "Pack Platine", coins: "1800", price: "18.00" },
    { id: "9", name: "Pack Platine +", coins: "2000", price: "20.00" },
    { id: "10", name: "Pack Ultime", coins: "4500", price: "45.00" }
  ]);

  const openEdit = (pack) => {
    setSelectedPack({ ...pack });
    setModalVisible(true);
  };

  const saveModifs = () => {
    setPacks(
      packs.map((p) =>
        p.id === selectedPack.id ? selectedPack : p
      )
    );

    setModalVisible(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#000",
        padding: 15,
        color: "#fff"
      }}
    >
      <div style={{ maxWidth: 1400, margin: "0 auto" }}>
        <div
          style={{
            paddingTop: 20,
            paddingBottom: 20,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 10,
            flexWrap: "wrap"
          }}
        >
          <button
            onClick={() => {
              window.location.href = "/admin";
            }}
            style={{
              background: "transparent",
              border: "none",
              color: NEON_CYAN,
              fontWeight: "bold",
              cursor: "pointer"
            }}
          >
            ← RETOUR
          </button>

          <div
            style={{
              color: "#fff",
              fontWeight: "bold",
              fontSize: 18
            }}
          >
            CONFIG PACKS
          </div>

          <button
            style={{
              background: NEON_CYAN,
              padding: "8px 12px",
              borderRadius: 5,
              border: "none",
              fontWeight: "bold",
              cursor: "pointer"
            }}
          >
            + PACK
          </button>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(260px,1fr))",
            gap: 12
          }}
        >
          {packs.map((item) => (
            <div
              key={item.id}
              onClick={() => openEdit(item)}
              style={{
                background: "#051626",
                padding: 15,
                borderRadius: 12,
                border: "1px solid #1a2b3c",
                cursor: "pointer"
              }}
            >
              <div
                style={{
                  color: NEON_CYAN,
                  fontWeight: "bold",
                  fontSize: 12,
                  marginBottom: 8
                }}
              >
                {item.name}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    color: "#fff",
                    fontSize: 22,
                    fontWeight: "bold"
                  }}
                >
                  {item.coins}
                </div>

                <div
                  style={{
                    color: "#39ff14",
                    fontSize: 14,
                    fontWeight: "bold"
                  }}
                >
                  {item.price}€
                </div>
              </div>

              <div
                style={{
                  color: "#666",
                  fontSize: 10
                }}
              >
                coins
              </div>

              <div
                style={{
                  marginTop: 10,
                  background: "#00f2ff20",
                  padding: 6,
                  borderRadius: 4,
                  textAlign: "center"
                }}
              >
                <div
                  style={{
                    color: NEON_CYAN,
                    fontSize: 9,
                    fontWeight: "bold"
                  }}
                >
                  MODIFIER
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {modalVisible && selectedPack && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#0a1a2a",
              padding: 20,
              borderRadius: 15,
              border: `1px solid ${NEON_CYAN}`,
              width: "100%",
              maxWidth: 420
            }}
          >
            <div
              style={{
                color: "#fff",
                fontWeight: "bold",
                marginBottom: 20,
                textAlign: "center"
              }}
            >
              Modifier le Pack
            </div>

            <input
              value={selectedPack.name}
              onChange={(e) =>
                setSelectedPack({
                  ...selectedPack,
                  name: e.target.value
                })
              }
              placeholder="Nom"
              style={inputStyle}
            />

            <input
              value={selectedPack.coins}
              onChange={(e) =>
                setSelectedPack({
                  ...selectedPack,
                  coins: e.target.value
                })
              }
              placeholder="Coins"
              style={inputStyle}
            />

            <input
              value={selectedPack.price}
              onChange={(e) =>
                setSelectedPack({
                  ...selectedPack,
                  price: e.target.value
                })
              }
              placeholder="Prix"
              style={inputStyle}
            />

            <button
              onClick={saveModifs}
              style={{
                background: NEON_CYAN,
                padding: 15,
                borderRadius: 10,
                marginTop: 10,
                width: "100%",
                border: "none",
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              ENREGISTRER
            </button>

            <button
              onClick={() =>
                setModalVisible(false)
              }
              style={{
                background: "transparent",
                border: "none",
                color: "#666",
                width: "100%",
                marginTop: 15,
                cursor: "pointer"
              }}
            >
              Annuler
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const inputStyle = {
  width: "100%",
  background: "#000",
  color: "#fff",
  padding: 12,
  borderRadius: 8,
  marginBottom: 10,
  border: "1px solid #1a2b3c"
};

export default AdminPacksWebPage;
